import { motion } from "framer-motion";
import Seo from "@/components/seo/Seo";
import { organizationSchema, websiteSchema } from "@/lib/seo";
import { Hero } from "@/components/home/Hero";
import { Categories } from "@/components/home/Categories";
import { AbayAICard } from "@/components/home/AbayAICard";
import { PopularAreas } from "@/components/home/PopularAreas";
import { FeaturedProperties } from "@/components/home/FeaturedProperties";
import { BrowseByType } from "@/components/home/BrowseByType";
import { NewProjects } from "@/components/home/NewProjects";
import { MapSection } from "@/components/home/MapSection";
import { WhyAbay } from "@/components/home/WhyAbay";
import { PartnerBanks } from "@/components/home/PartnerBanks";
import { Testimonials } from "@/components/home/Testimonials";
import { MobileApp } from "@/components/home/MobileApp";
import { LatestNews } from "@/components/home/LatestNews";
import { pageTransition } from "@/lib/motion";

export default function Home() {
  return (
    <motion.div variants={pageTransition} initial="initial" animate="animate" exit="exit">
      <Seo
        title="ABAY360 — Find, Buy, Rent & Invest in Ethiopian Property"
        titleFull
        description="Ethiopia's smartest AI-powered real estate platform. Search verified homes, land and commercial property to buy or rent, with AI valuations, insights and fraud checks across Addis Ababa and beyond."
        path="/"
        schema={[organizationSchema(), websiteSchema()]}
      />

      {/* 1. Hero (dark image) — AI search + voice + Near Me / Map / Filters */}
      <Hero />

      {/* Quick category cards (Buy / Rent / Land / Commercial) — white */}
      <Categories />

      {/* 2. Abay AI Showcase — dark banner (AI-first differentiator) */}
      <AbayAICard />

      {/* 3. Popular Areas — white */}
      <PopularAreas />

      {/* 4. Featured Properties — light gray (AI Recommended / Featured / Luxury / Affordable) */}
      <FeaturedProperties />

      {/* 5. Browse by Property Type — white (House / Apartment / Commercial / Land) */}
      <BrowseByType />

      {/* 6. New Projects — light gray (off-plan, mortgage eligible, early pricing) */}
      <NewProjects />

      {/* 7. Interactive Ethiopia Map — light blue */}
      <MapSection />

      {/* 8. Why ABAY360 — white (4 short cards) */}
      <WhyAbay />

      {/* 9. Partner Banks & Mortgage — light gray */}
      <PartnerBanks />

      {/* 10. Testimonials — white (carousel) */}
      <Testimonials />

      {/* 11. Download App — dark blue (premium app launch) */}
      <MobileApp />

      {/* 12. Latest News — white */}
      <LatestNews />

      {/* Professional footer is rendered globally by AppLayout */}
    </motion.div>
  );
}
